export default {"src":"/_next/static/media/edit_user.98daa9be.svg","height":20,"width":24};